import {array, Decoder, field, number, object} from 'json-bouncer'

export interface ProductCalculation {
    id: number
    typeMessageId: number
    formatMessageId: number
    coverageMessageId: number
    printMessageId: number
    paperMessageId: number
    processingMessageId: number
    productShippingServiceId: number
    weight: number
    manufacturerId: number
}

export function  productCalculationListDecoder(): Decoder<ProductCalculation[]> {
    return array(productCalculationDecoder())
}

export function productCalculationDecoder(): Decoder<ProductCalculation> {
    return object({
        id: field('id', number()),
        typeMessageId: field('typeMessageId', number()),
        formatMessageId: field('formatMessageId', number()),
        coverageMessageId: field('coverageMessageId', number()),
        printMessageId: field('printMessageId', number()),
        paperMessageId: field('paperMessageId', number()),
        processingMessageId: field('processingMessageId', number()),
        productShippingServiceId: field('productShippingServiceId', number()),
        weight: field('weight', number()),
        manufacturerId: field('manufacturerId', number())
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ProductCalculation.ts